import React, { useEffect, useState, useRef } from 'react';
const companies = [{
  name: 'Harvey',
  logo: 'https://logo.clearbit.com/harvey.ai',
  fallback: 'Harvey'
}, {
  name: 'Affirm',
  logo: 'https://logo.clearbit.com/affirm.com',
  fallback: 'Affirm'
}, {
  name: 'Robinhood',
  logo: 'https://logo.clearbit.com/robinhood.com',
  fallback: 'Robinhood'
}, {
  name: 'Cash App',
  logo: 'https://logo.clearbit.com/cash.app',
  fallback: 'Cash App'
}, {
  name: 'Nextdoor',
  logo: 'https://logo.clearbit.com/nextdoor.com',
  fallback: 'Nextdoor'
}, {
  name: 'Carta',
  logo: 'https://logo.clearbit.com/carta.com',
  fallback: 'Carta'
}, {
  name: 'BRM',
  logo: 'https://logo.clearbit.com/brm.io',
  fallback: 'BRM'
}];
function CompanyLogo({
  company
}: {
  company: (typeof companies)[0];
}) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <span className="text-xl font-bold tracking-tight" style={{
      color: 'var(--ink-muted)',
      opacity: 0.5
    }} data-id="element-37">
        {company.fallback}
      </span>;
  }
  return <img src={company.logo} alt={company.name} className="h-7 w-auto object-contain transition-all duration-300" style={{
    filter: 'grayscale(100%) opacity(0.45)'
  }} onError={() => setFailed(true)} onMouseEnter={e => e.currentTarget.style.filter = 'grayscale(0%) opacity(1)'} onMouseLeave={e => e.currentTarget.style.filter = 'grayscale(100%) opacity(0.45)'} data-id="element-38" />;
}
export function LogoStrip() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.2
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <section ref={ref} className="py-16 px-6 border-t border-b" style={{
    borderColor: 'var(--border)'
  }} data-id="element-39">
      <div className="max-w-6xl mx-auto" data-id="element-40">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 sm:gap-12 transition-all duration-700 ease-out" style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(16px)'
      }} data-id="element-41">
          <p className="whitespace-nowrap flex-shrink-0" style={{
          color: 'var(--text-muted)',
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-body)',
          fontWeight: '400'
        }} data-id="element-42">
            Our team has worked at
          </p>
          <div className="w-px h-8 hidden sm:block flex-shrink-0" style={{
          backgroundColor: 'var(--border)'
        }} data-id="element-43" />
          <div className="flex flex-wrap items-center justify-start gap-8 sm:gap-12" data-id="element-44">
            {companies.map(company => <CompanyLogo key={company.name} company={company} data-id="element-45" />)}
          </div>
        </div>
      </div>
    </section>;
}